import React from 'react'
import { Tooltip } from 'antd'

const CircuitButtonTooltip = ({ displays, t, children }) => {

  const hasMultipleFaces = displays.filter(display => display.mirror_screens_count > 1).length

  return (
    <Tooltip 
      title={
        `${t("The circuit has")} ${displays.length} ${t("screens")} 
          ${hasMultipleFaces ? `${t("and")} ${hasMultipleFaces} ${hasMultipleFaces > 1 ? t("have multiple faces") : t("has multiple faces")}` : ""}`
      }
      placement="top"
    >
      {children}
    </Tooltip>
  )
}

export default CircuitButtonTooltip